module.exports = {
  "/": {
    "name": "index",
    "success": {
      "index page loaded": [
        "INDEX_LOAD"
      ]
    }
  },
  "/apps": {
    "name": "apps",
    "success": {
      "apps page loaded": [
        "APPS_LOAD"
      ]
    }
  },
  "/apps/all": {
    "name": "allApps",
    "success": {
      "all apps search results page loaded": [
        "SEARCH_RESULTS_LOAD"
      ]
    }
  },
  "/apps/:categorySlug": {
    "name": "appsCategory",
    "success": {
      "apps category search results page loaded": [
        "SEARCH_RESULTS_LOAD"
      ]
    }
  },
  "/apps/:categorySlug/page/:page": {
    "name": "appsCategoryPage",
    "success": {
      "apps category search results page loaded": [
        "SEARCH_RESULTS_LOAD"
      ]
    }
  },
  "/breeze-agents": {
    "name": "agents",
    "success": {
      "agents page loaded": [
        "AGENTS_LOAD"
      ]
    }
  },
  "/breeze-agents/all": {
    "name": "agentsAll",
    "success": {
      "agents all search results page loaded": [
        "SEARCH_RESULTS_LOAD"
      ]
    }
  },
  "/breeze-agents/all/page/:page": {
    "name": "agentsAllPage",
    "success": {
      "agents all search results page loaded": [
        "SEARCH_RESULTS_LOAD"
      ]
    }
  },
  "/breeze-agents/:teamSlug": {
    "name": "agentsTeam",
    "success": {
      "agents team search results page loaded": [
        "SEARCH_RESULTS_LOAD"
      ]
    }
  },
  "/breeze-agents/:teamSlug/page/:page": {
    "name": "agentsTeamPage",
    "success": {
      "agents team search results page loaded": [
        "SEARCH_RESULTS_LOAD"
      ]
    }
  },
  "/featured": {
    "name": "featured",
    "success": {
      "featured page loaded": [
        "FEATURED_LOAD"
      ]
    }
  },
  "/featured/page/:page": {
    "name": "featuredPage",
    "success": {
      "featured page loaded": [
        "FEATURED_LOAD"
      ]
    }
  },
  "/featured/:collectionSlug": {
    "name": "featuredCollection",
    "success": {
      "featured collection page loaded": [
        "COLLECTION_LOAD"
      ]
    }
  },
  "/explore": {
    "name": "explore",
    "success": {
      "explore page loaded": [
        "SEARCH_RESULTS_LOAD"
      ]
    }
  },
  "/explore/page/:page": {
    "name": "explorePage",
    "success": {
      "explore page loaded": [
        "SEARCH_RESULTS_LOAD"
      ]
    }
  },
  "/explore/products": {
    "name": "exploreProducts",
    "success": {
      "explore products page loaded": [
        "SEARCH_RESULTS_LOAD"
      ]
    }
  },
  "/explore/solutions-partners": {
    "name": "exploreSolutionsPartners",
    "success": {
      "explore solutions partners page loaded": [
        "SEARCH_RESULTS_LOAD"
      ]
    }
  },
  "/listing/:listingSlug": {
    "name": "listingDetails",
    "success": {
      "listing details page loaded": [
        "LISTING_DETAILS_LOAD"
      ],
      "listing details error loaded": [
        "LISTING_DETAILS_ERROR_LOAD"
      ]
    }
  },
  "/install-success": {
    "name": "installSuccess",
    "success": {
      "install success loaded": [
        "INSTALL_SUCCESS_LOAD"
      ]
    }
  },
  "/third-party-auth-state": {
    "name": "thirdPartyAuthState",
    "success": {
      "third party auth state loaded": [
        "THIRD_PARTY_AUTH_STATE_LOAD"
      ]
    }
  },
  "/solutions": {
    "name": "solutions",
    "success": {
      "solutions page loaded": [
        "SOLUTIONS_PARTNERS_LOAD"
      ]
    }
  },
  "/solutions/:categorySlug/write-review": {
    "name": "solutionsWriteReview",
    "success": {
      "solutions write review page loaded": [
        "WRITE_REVIEW_LOAD"
      ],
      "solutions write review error loaded": [
        "WRITE_REVIEW_ERROR_LOAD"
      ]
    }
  },
  "/solutions/all": {
    "name": "solutionsAll",
    "success": {
      "solutions all search results page loaded": [
        "SEARCH_RESULTS_LOAD"
      ]
    }
  },
  "/solutions/all/page/:page": {
    "name": "solutionsAllPage",
    "success": {
      "solutions all search results page loaded": [
        "SEARCH_RESULTS_LOAD"
      ]
    }
  },
  "/solutions/:categorySlug": {
    "name": "solutionsCategory",
    "success": {
      "solutions category search results page loaded": [
        "SEARCH_RESULTS_LOAD"
      ],
      "solutions partner profile page loaded": [
        "LISTING_DETAILS_LOAD"
      ],
      "solutions partner profile error loaded": [
        "LISTING_DETAILS_ERROR_LOAD"
      ]
    }
  },
  "/solutions/:categorySlug/:subcategorySlug": {
    "name": "solutionsCategorySubcategory",
    "success": {
      "solutions subcategory search results page loaded": [
        "SEARCH_RESULTS_LOAD"
      ]
    }
  },
  "/solutions/:categorySlug/:subcategorySlug/:subcategory2Slug": {
    "name": "solutionsCategorySubcategory2",
    "success": {
      "solutions subcategory2 search results page loaded": [
        "SEARCH_RESULTS_LOAD"
      ]
    }
  }
};